module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_library.js
 ** module id = 28
 ** module chunks = 1
 **/